import { Typography } from '@kohler-dsm-library/kohler-core';
import React from 'react';
import clsx from 'clsx';
import classes from './index.module.scss';

export const NavigationItem = React.forwardRef((props, ref) => {
  const { text, isSelected, className, href, component, ...rest } = props;

  return (
    <Typography
      component={component || (href ? 'a' : 'span')}
      {...(href ? { href } : {})}
      size="label-medium-m"
      className={clsx(
        className,
        isSelected ? classes.navigationItemSelected : classes.navigationItem
      )}
      style={{
        color: isSelected
          ? 'var(--Primary-Charcoal, #212121)'
          : 'var(--Primary-Carbon, #5D5D5D)',
      }}
      ref={ref}
      {...rest}
    >
      {text}
    </Typography>
  );
});